import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  tramits: {
    id: 'Tramits',
    defaultMessage: 'Tràmits',
  },
  categories: {
    id: 'Categories',
    defaultMessage: 'Categories',
  },
  linkTitle: {
    id: 'Link title',
    defaultMessage: 'Link title',
  },
});

export const schema = (props) => {
  return {
    required: ['title'],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'title', 
          'description', 
          'tramits',
          'categories',
          'linkTitle',
          'linkUrl',
        ],
      },
    ],
    properties: {
      title: {
        title: props.intl.formatMessage(messages.title),
        widget: 'text',
      },
      description: {
        title: props.intl.formatMessage(messages.description),
        widget: 'textarea',
      },
      tramits: {
        title: props.intl.formatMessage(messages.tramits),
        type: 'array',
        items: {
          type: 'choice',
          vocabulary: {
            '@id': 'product.palafolls.vocabularies.Tramits',
          },
        },
      },
      categories: {
        title: props.intl.formatMessage(messages.categories),
        type: 'array',
        items: {
          type: 'choice',
          vocabulary: {
            '@id': 'product.palafolls.vocabularies.TramitCategories',
          },
        },
      },
      linkTitle: {
        title: props.intl.formatMessage(messages.linkTitle),
        widget: 'text',
      },
      linkUrl: {
        title: 'URL',
        widget: 'url',
        allow_external: true,
      },
    },
  };
};

export default schema;